/* eslint-disable @nx/enforce-module-boundaries */
import { Component, DestroyRef, Input, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  ReactiveFormsModule,
  FormGroup,
} from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { take } from 'rxjs';
import { VehicleTypesService } from 'admin-drivers/src/app/api/services/vehicle-types.service';
import { VehicleTypeResponse } from 'admin-drivers/src/app/api/models/responses/VehicleTypeResponse';
import { VehicleType } from 'admin-drivers/src/app/common/models/VehicleType';

@Component({
  selector: 't-llevo-edit-vehicle-form',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatInputModule,
    MatFormFieldModule,
    MatSelectModule,
  ],
  templateUrl: './edit-vehicle-form.component.html',
  styles:`
    @import '../../../../utils/styles/formGroup.scss';
    .vehicleForm {
      display: grid;
      grid-template-columns: repeat(2, 1fr);

      & mat-form-field:nth-child(-n + 5) {
        width: 90%;
        justify-self: center;
      }
    }
  `
})
export class EditVehicleFormComponent {
  private destroyRef = inject(DestroyRef);
  private vehicleTypesSrv = inject(VehicleTypesService)

  protected vehicleTypes: VehicleType[] = [];
  protected colors = this.vehicleTypesSrv.vehicleColors

  @Input({required: true}) frm! : FormGroup

  constructor() {
    this.vehicleTypesSrv.vehicleTypes$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (data) => {
          if (data) {
            this.vehicleTypes = data;
          } else {
            this.vehicleTypesSrv.getVehicleTypes().pipe(take(1)).subscribe();
          }
        },
      });
  }

  get vehicleType() {
    return this.frm.controls['vehicleType'];
  }

  get mark() {
    return this.frm.controls['mark'];
  }

  get model() {
    return this.frm.controls['model'];
  }

  get color() {
    return this.frm.controls['color'];
  }

  get plate() {
    return this.frm.controls['plate'];
  }
}
